module.exports = __webpack_public_path__ + "static/media/Agent5.b90c978c.jpg";